// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fec8f08a","455":"5752d2c9","916":"58b3fa76","946":"e82cac1a","970":"603c1ae5"}[chunkId] + ".chunk.js";
};